module.exports = __webpack_public_path__ + "img/img4_3.c5189a28.jpeg";